var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrosage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "19B839AD-30A5-4F08-935E-56B3E6058C88") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V1-hp-Copy",
    transform: "translate(-331.000000, -739.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MENU",
    transform: "translate(0.000000, 725.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(331.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#C4CF15",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("g", {
    id: "arrosage-(1)",
    transform: "translate(13.000000, 14.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4628113,12.442652 C24.1376554,12.3088085 23.7633637,12.3827686 23.5144933,12.6302636 L20.8999621,15.2304032 L15.6405014,14.7945467 L18.6488164,10.2980992 C18.8784269,9.95489464 18.8327716,9.49832696 18.5396383,9.20687132 L12.4528722,3.15368616 C12.1598549,2.86223052 11.7007499,2.8167699 11.3555221,3.04511143 L10.5611093,3.57073541 C10.3908448,2.71656039 9.97112983,1.9312686 9.33798967,1.30168519 C8.49397682,0.462279104 7.37173965,0 6.17809003,0 C4.98444041,0 3.86220325,0.462279104 3.01813239,1.30168519 C1.2758077,3.03443857 1.2758077,5.85380458 3.01813239,7.58661566 C3.22186963,7.78922694 3.44219823,7.96933868 3.67546345,8.1267778 L1.2940814,9.7024959 C0.567252278,10.1833516 0.100837865,10.9546821 0.0144583799,11.8184915 C-0.0720371286,12.6824163 0.23246651,13.5299569 0.849711453,14.1437906 L7.48845928,20.7458493 C8.03672826,21.2911459 8.77034476,21.5909091 9.5362738,21.5909091 C9.63263131,21.5909091 9.72956893,21.5861207 9.82662258,21.576544 C10.6953484,21.4905842 11.4709074,21.0268051 11.9544353,20.3039928 L12.5733046,19.3790308 L20.8999621,18.6889871 L23.5145513,21.2891267 C23.680987,21.4547003 23.9035781,21.5426216 24.1299979,21.5426216 C24.2421346,21.5426216 24.3551995,21.5210451 24.4628113,21.4767383 C24.7879671,21.3427795 25,21.0272667 25,20.6772545 L25,13.2421935 C25,12.8921813 24.7879671,12.5766108 24.4628113,12.442652 Z M4.24873549,6.36281351 C3.18497416,5.30487338 3.18497416,3.58342746 4.24873549,2.52548734 C4.76411181,2.01301694 5.4492305,1.73079189 6.17809003,1.73079189 C6.90689156,1.73079189 7.59201024,2.01301694 8.10738657,2.52554503 C8.62276289,3.03801542 8.90649832,3.71940548 8.90649832,4.44417927 C8.90649832,4.5207931 8.90261154,4.59683002 8.89634627,4.67234773 L5.33842807,7.02655007 C4.9319978,6.89622578 4.55938837,6.67169187 4.24873549,6.36281351 Z",
    id: "XMLID_1585_"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrosage);
export default __webpack_public_path__ + "static/media/arrosage.8c4d09074355ae70591393e488e9858b.svg";
export { ForwardRef as ReactComponent };